var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-template",
    [
      _c("template", { slot: "page-content" }, [
        _c("div", { staticClass: "generic--template page-template bg-beige" }, [
          _c("div", { staticClass: "relative z-content pv4" }, [
            _c(
              "div",
              { staticClass: "relative container-fluid mw9 center tl" },
              [
                _c(
                  "h1",
                  {
                    staticClass:
                      "f-page-title mv0 ttu tl lh-title f2 f1-ns is-blenny is-navy",
                  },
                  [_vm._v(_vm._s(_vm.page.title))]
                ),
              ]
            ),
            _vm._v(" "),
            _c("section", { staticClass: "relative" }, [
              _c(
                "div",
                { staticClass: "relative container-fluid mw9 center" },
                [
                  _c(
                    "div",
                    { staticClass: "row mt4 mt3-ns" },
                    _vm._l(_vm.page.admat_section.admats, function (item) {
                      return _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-6 mb4 mb0-ns" },
                        [
                          _c("div", { staticClass: "relative center ph3" }, [
                            _c(
                              "h2",
                              {
                                staticClass:
                                  "f2 f1-ns mv2 tc is-lorano-bold is-navy",
                              },
                              [_vm._v(_vm._s(item.title))]
                            ),
                            _vm._v(" "),
                            _c("img", {
                              directives: [
                                {
                                  name: "lazy",
                                  rawName: "v-lazy",
                                  value: item.image,
                                  expression: "item.image",
                                },
                              ],
                              staticClass:
                                "db relative mv3 center mw-100 admat-border",
                            }),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }